import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const COMPANYCODE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.CompanyCode.Name')
    .required()
    .minLength(1)
    .maxLength(150)
    .build(),
  FieldBuilder
    .text('code', 'Entity.CompanyCode.Code')
    .required()
    .minLength(2)
    .maxLength(10)
    .build(),
  FieldBuilder
    .text('oldSapCode', 'Entity.CompanyCode.OldSapCode')
    .maxLength(20)
    .build(),
];

export const COMPANYCODE_CONFIG = {
  entityName: 'CompanyCode',
  localizationKey: 'Controlling::Entity.CompanyCode',
  fields: COMPANYCODE_FIELDS,
  permission: 'ControllingSap.CompanyCodes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
